"use strict";
exports.HASURA_ROLES = Object.freeze({
    ADMIN: 'admin',
    UPANDUPADMIN: 'upandupadmin',
    CONSTRUCTION_PROJECT_VIEWER: 'construction_project_viewer',
    USER: 'user',
    ANONYMOUS: 'anonymous'
});
